import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4b90e851&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4b90e851&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b90e851",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\androidcode\\zf_tms_vue\\tms_vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b90e851')) {
      api.createRecord('4b90e851', component.options)
    } else {
      api.reload('4b90e851', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4b90e851&scoped=true", function () {
      api.rerender('4b90e851', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Generator/components/PopupSelectpc/index.vue"
export default component.exports